(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('MonedaDialogController', MonedaDialogController);

    MonedaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Moneda', 'Comercio'];

    function MonedaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Moneda, Comercio) {
        var vm = this;

        vm.moneda = entity;
        vm.clear = clear;
        vm.save = save;
        vm.comercios = Comercio.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.moneda.id !== null) {
                Moneda.update(vm.moneda, onSaveSuccess, onSaveError);
            } else {
                Moneda.save(vm.moneda, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('mVtasWebApp:monedaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
